module.exports = "/static/assets/dc9a6522e00a350de415ff35da0cc893.png";